module.exports = __webpack_public_path__ + "media/src/images/mail_conformed-4bb90f4c7fa5586ea19cd6935727f12c.svg";